/**
 * Mock data for Purchase Requisition & Purchase Order APIs.
 * Remove this file when backend is ready and USE_MOCK_PR_PO_DATA is set to false.
 */
import { PurchaseOrder, PurchaseRequisition } from 'src/API';

export const MOCK_PURCHASE_REQUISITION: PurchaseRequisition = {
  id: '188445',
  name: 'QA testing services H2',
  status: 'Pending approval',
  requester_alias: 'borasura',
  requester_id: 'EMP-001',
  budget_line_id: 'bl-002',
  org_id: 'org-001',
  ofa_vendor_number: '11111',
  amazon_supplier_entity_id: 'sup-004',
  amazon_supplier_display_name: 'Applause Inc.',
  region: 'NAMER',
  country_code: 'US',
  currency_code: 'USD',
  payment_terms: 'Net 30',
  shipping_address_id: 'addr-001',
  personal_service_company_engagement: false,
  contains_gift: false,
  gift_over_limit: null,
  gift_approval_link: null,
  dealing_with_government: false,
  anti_corruption_report_link: null,
  business_justification: 'QA testing services for H2 product release cycle',
  description_of_what_purchase_order_includes: 'QA testing services',
  supplier_text: null,
  send_text_to_supplier: false,
  chart_of_accounts: '6310',
  chart_of_accounts_name: 'Professional Services',
  cash_donation_or_grant: null,
  cash_sponsorship: null,
  community_giving_pre_approval_link: null,
  multiyear_po: false,
  marketing_info: null,
  requisition_lines: [
    { id: '1', line_num: 1, description: 'Research & surveys - Annual platform', quantity: 1, unit_price: 14500, total: 14500, unit_price_in_usd: 14500, need_by_date: '2026-07-30', status: 'pending', budget_line_id: 'bl-002', account_code: 'D2-7128-6310-64711-0000-0000-0000', account_allocations: null, cost_center: '7128', commodity_id: 'cat-001', commodity_type: 'Professional Services', commodity_item: 'Consulting', commodity_name: 'IT Services', forecast: null, supplier_entity_id: null, supplier_name: null },
    { id: '2', line_num: 2, description: 'Survey design and implementation', quantity: 3, unit_price: 2000, total: 6000, unit_price_in_usd: 2000, need_by_date: '2026-08-15', status: 'pending', budget_line_id: 'bl-002', account_code: 'D2-7128-6310-64711-0000-0000-0000', account_allocations: null, cost_center: '7128', commodity_id: 'cat-001', commodity_type: 'Professional Services', commodity_item: 'Consulting', commodity_name: 'IT Services', forecast: null, supplier_entity_id: null, supplier_name: null },
    { id: '3', line_num: 3, description: 'Data analysis and reporting', quantity: 1, unit_price: 3000, total: 3000, unit_price_in_usd: 3000, need_by_date: '2026-09-01', status: 'pending', budget_line_id: 'bl-002', account_code: 'D2-7128-6310-64711-0000-0000-0000', account_allocations: null, cost_center: '7128', commodity_id: 'cat-001', commodity_type: 'Professional Services', commodity_item: 'Consulting', commodity_name: 'IT Services', forecast: null, supplier_entity_id: null, supplier_name: null }
  ],
  approvals: [
    { id: 'appr-1', status: 'approved', approver_alias: 'borasura', approver_name: 'Borasura', approved_at: '2026-06-05T00:00:00Z', position: 1, approval_type: 'Submitted' },
    { id: 'appr-2', status: 'approved', approver_alias: 'johndoe', approver_name: 'John Doe', approved_at: '2026-06-06T00:00:00Z', position: 2, approval_type: 'Manager approval' },
    { id: 'appr-3', status: 'pending', approver_alias: 'finowner', approver_name: 'Finance Owner', approved_at: null, position: 3, approval_type: 'Finance approval' }
  ],
  current_approval: { id: 'appr-3', status: 'pending', approver_alias: 'finowner', approver_name: 'Finance Owner', approved_at: null, position: 3, approval_type: 'Finance approval' },
  total: 28000,
  local_currency_total: 28000,
  created_at: '2026-06-01T00:00:00Z',
  updated_at: '2026-06-08T00:00:00Z',
  submitted_at: '2026-06-05T00:00:00Z'
};

export const MOCK_PURCHASE_ORDER: PurchaseOrder = {
  id: '2D-100452',
  po_number: '2D-100452',
  status: 'Approved',
  budget_line_id: '716489',
  supplier_entity_id: 'sup-001',
  supplier_name: 'Qualtrics International',
  ofa_vendor_number: '56789',
  currency_code: 'USD',
  total: 24500,
  requester_alias: 'borasura',
  requester_id: 'EMP-001',
  created_at: '2024-01-12T00:00:00Z',
  updated_at: '2024-02-04T00:00:00Z',
  acknowledged_at: null,
  shipping_address_id: 'addr-001',
  requisition_id: '188520',
  order_lines: [
    { id: '1', line_num: 1, description: 'Research & surveys - Q1 platform access', quantity: 1, price: 14500, total: 14500, currency_code: 'USD', account_code: 'D2-7128-6310-64711-0000-0000-0000', cost_center: '7128', budget_type: 'NRE', commodity_id: 'cat-001', commodity_type: 'Professional Services', commodity_item: 'Consulting', need_by_date: '2024-03-01', created_at: '2024-01-12T00:00:00Z', updated_at: null },
    { id: '2', line_num: 2, description: 'Survey design and implementation', quantity: 3, price: 2000, total: 6000, currency_code: 'USD', account_code: 'D2-7128-6310-64711-0000-0000-0000', cost_center: '7128', budget_type: 'NRE', commodity_id: 'cat-001', commodity_type: 'Professional Services', commodity_item: 'Consulting', need_by_date: '2024-03-15', created_at: '2024-01-12T00:00:00Z', updated_at: null },
    { id: '3', line_num: 3, description: 'Data analysis and reporting', quantity: 1, price: 3000, total: 3000, currency_code: 'USD', account_code: 'D2-7128-6310-64711-0000-0000-0000', cost_center: '7128', budget_type: 'NRE', commodity_id: 'cat-001', commodity_type: 'Professional Services', commodity_item: 'Consulting', need_by_date: '2024-04-01', created_at: '2024-01-12T00:00:00Z', updated_at: null },
    { id: '4', line_num: 4, description: 'Participant recruitment', quantity: 50, price: 12, total: 600, currency_code: 'USD', account_code: 'D2-7128-6310-64711-0000-0000-0000', cost_center: '7128', budget_type: 'NRE', commodity_id: 'cat-001', commodity_type: 'Professional Services', commodity_item: 'Consulting', need_by_date: '2024-04-15', created_at: '2024-01-12T00:00:00Z', updated_at: null },
    { id: '5', line_num: 5, description: 'Project management', quantity: 10, price: 240, total: 2400, currency_code: 'USD', account_code: 'D2-7128-6310-64711-0000-0000-0000', cost_center: '7128', budget_type: 'NRE', commodity_id: 'cat-001', commodity_type: 'Professional Services', commodity_item: 'Consulting', need_by_date: '2024-05-01', created_at: '2024-01-12T00:00:00Z', updated_at: null }
  ],
  approvals: [
    { id: 'appr-1', status: 'approved', approver_alias: 'borasura', approver_name: 'Borasura', approved_at: '2024-01-12T00:00:00Z', position: 1, approval_type: 'Submitted' },
    { id: 'appr-2', status: 'approved', approver_alias: 'johndoe', approver_name: 'John Doe', approved_at: '2024-01-13T00:00:00Z', position: 2, approval_type: 'Manager approval' },
    { id: 'appr-3', status: 'approved', approver_alias: 'finowner', approver_name: 'Finance Owner', approved_at: '2024-01-14T00:00:00Z', position: 3, approval_type: 'Finance approval' },
    { id: 'appr-4', status: 'approved', approver_alias: null, approver_name: null, approved_at: '2024-01-15T00:00:00Z', position: 4, approval_type: 'PO created' }
  ],
  region: 'NAMER',
  country_code: 'US',
  payment_terms: 'Net 30',
  cost_center: '7128',
  budget_type: 'NRE',
  fiscal_year: 'FY2024'
};

// --- Dropdown Mock Data ---

import { CoupaCategory, FxRate, ShippingAddress, Supplier } from 'src/API';

export const MOCK_SUPPLIERS: Supplier[] = [
  { entity_id: 'sup-001', display_name: 'Qualtrics International', ofa_vendor_number: '56789', supplier_currency: 'USD', po_country_code: 'US', po_region: 'NAMER', enabled_for_org: true, payment_terms: '30 NET' },
  { entity_id: 'sup-002', display_name: 'Bragi GmbH', ofa_vendor_number: '12345', supplier_currency: 'EUR', po_country_code: 'DE', po_region: 'EMEA', enabled_for_org: true, payment_terms: '60 NET' },
  { entity_id: 'sup-003', display_name: 'EP Systems Inc.', ofa_vendor_number: '67890', supplier_currency: 'USD', po_country_code: 'US', po_region: 'NAMER', enabled_for_org: true, payment_terms: '30 NET' },
  { entity_id: 'sup-004', display_name: 'Applause Inc.', ofa_vendor_number: '11111', supplier_currency: 'USD', po_country_code: 'US', po_region: 'NAMER', enabled_for_org: true, payment_terms: '45 NET' },
  { entity_id: 'sup-005', display_name: 'Tech NRE Vendors Co.', ofa_vendor_number: '22222', supplier_currency: 'JPY', po_country_code: 'JP', po_region: 'APJ', enabled_for_org: true, payment_terms: 'Payable Upon Receipt' }
];

export const MOCK_COUPA_CATEGORIES: CoupaCategory[] = [
  { id: 'cat-001', label: 'IT Services', type: 'Professional Services', item: 'Consulting' },
  { id: 'cat-002', label: 'IT Services', type: 'Professional Services', item: 'Staff Augmentation' },
  { id: 'cat-003', label: 'IT Services', type: 'Software', item: 'SaaS Subscription' },
  { id: 'cat-004', label: 'IT Services', type: 'Software', item: 'On-premise License' },
  { id: 'cat-005', label: 'Marketing', type: 'Advertising', item: 'Digital Campaign' },
  { id: 'cat-006', label: 'Marketing', type: 'Advertising', item: 'Print Media' },
  { id: 'cat-007', label: 'Marketing', type: 'Events', item: 'Conference Sponsorship' },
  { id: 'cat-008', label: 'Hardware', type: 'Computing', item: 'Servers' },
  { id: 'cat-009', label: 'Hardware', type: 'Computing', item: 'Laptops' },
  { id: 'cat-010', label: 'Hardware', type: 'Networking', item: 'Routers' },
  { id: 'cat-011', label: 'Research', type: 'Market Research', item: 'Survey Platform' },
  { id: 'cat-012', label: 'Research', type: 'Market Research', item: 'Focus Groups' },
  { id: 'cat-013', label: 'Research', type: 'User Research', item: 'Usability Testing' }
];

export const MOCK_SHIPPING_ADDRESSES: ShippingAddress[] = [
  { id: 'addr-001', label: 'SEA43 - Day 1 Building', address: '2121 7th Ave, Seattle, WA 98121', country_code: 'US' },
  { id: 'addr-002', label: 'SEA80 - Fiona', address: '2031 7th Ave, Seattle, WA 98121', country_code: 'US' },
  { id: 'addr-003', label: 'SFO15 - San Francisco', address: '375 Beale St, San Francisco, CA 94105', country_code: 'US' },
  { id: 'addr-004', label: 'LHR14 - London', address: '1 Principal Place, London EC2A 2FA', country_code: 'GB' }
];

export const MOCK_FX_RATES: FxRate[] = [
  { currency_code: 'USD', exchange_rate: 1 },
  { currency_code: 'EUR', exchange_rate: 0.92 },
  { currency_code: 'GBP', exchange_rate: 0.79 },
  { currency_code: 'JPY', exchange_rate: 157.5 },
  { currency_code: 'CAD', exchange_rate: 1.37 },
  { currency_code: 'AUD', exchange_rate: 1.53 },
  { currency_code: 'INR', exchange_rate: 83.5 },
  { currency_code: 'CNY', exchange_rate: 7.26 },
  { currency_code: 'BRL', exchange_rate: 5.15 }
];

// --- Generate mock PR list for Show POs page ---

const MOCK_VENDORS = ['Qualtrics International', 'Bragi GmbH', 'EP Systems Inc.', 'Applause Inc.', 'Tech NRE Vendors Co.', 'Marketing Agency Ltd.', 'Chelsea Research Ltd.', 'Partner Incentives Ltd.', 'Acme Corp.', 'GlobalTech Solutions'];
const MOCK_DESCRIPTIONS = ['Research & Surveys - Annual License', 'Hardware NRE - Prototype Boards', 'QA testing services H2', 'NRE hardware services Q3', 'User research - Beta program', 'Cloud infrastructure setup', 'Software license renewal', 'Consulting services Q3', 'Security audit services', 'UX design contract'];
const MOCK_STATUSES = ['Pending approval', 'Approved', 'Ordered', 'Draft', 'Denied'];

export const generateMockPurchaseRequisitions = (budgetLineId: string): PurchaseRequisition[] => {
  return Array.from({ length: 50 }, (_, i) => {
    const status = MOCK_STATUSES[i % MOCK_STATUSES.length];
    const hasPoNumber = status === 'Ordered';
    return {
      id: String(188400 + i),
      name: MOCK_DESCRIPTIONS[i % MOCK_DESCRIPTIONS.length],
      status,
      po_number: hasPoNumber ? `2D-${100400 + i}` : null,
      requester_alias: 'borasura',
      requester_id: 'EMP-001',
      budget_line_id: budgetLineId,
      org_id: 'org-001',
      ofa_vendor_number: String(10000 + i),
      amazon_supplier_entity_id: `sup-${(i % 5) + 1}`,
      amazon_supplier_display_name: MOCK_VENDORS[i % MOCK_VENDORS.length],
      region: 'NAMER',
      country_code: 'US',
      currency_code: 'USD',
      payment_terms: '30 NET',
      shipping_address_id: 'addr-001',
      personal_service_company_engagement: false,
      contains_gift: false,
      gift_over_limit: null,
      gift_approval_link: null,
      dealing_with_government: false,
      anti_corruption_report_link: null,
      business_justification: `Business justification for PR ${188400 + i}`,
      description_of_what_purchase_order_includes: MOCK_DESCRIPTIONS[i % MOCK_DESCRIPTIONS.length],
      supplier_text: null,
      send_text_to_supplier: false,
      chart_of_accounts: '6310',
      chart_of_accounts_name: 'Professional Services',
      cash_donation_or_grant: null,
      cash_sponsorship: null,
      community_giving_pre_approval_link: null,
      multiyear_po: false,
      marketing_info: null,
      requisition_lines: [],
      approvals: [],
      current_approval: null,
      total: Math.floor(Math.random() * 90000) + 10000,
      local_currency_total: Math.floor(Math.random() * 90000) + 10000,
      created_at: `2026-${String((i % 3) + 4).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}T00:00:00Z`,
      updated_at: `2026-06-${String((i % 28) + 1).padStart(2, '0')}T00:00:00Z`,
      submitted_at: `2026-${String((i % 3) + 4).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}T00:00:00Z`,
    };
  });
};
